import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AppState } from "../app.service";
import { Router } from "@angular/router";
import { AlertService } from "../services/index";

@Injectable()
export class APIInterceptor implements HttpInterceptor {
    private loginUrl: string = '/account/login';
    private excludeJsonHeaders: Array<string> = [
        '/api/getsecuretoken'
    ];

    private excludeAuthorizationHeader: Array<string> = [
        '/api/getsecuretoken'
    ];

    constructor(
        private appState: AppState,
        private router: Router,
        private alertService: AlertService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let options = {
            url: this.baseUrl() + req.url,
            headers: req.headers
        }

        if (this.excludeJsonHeaders.indexOf(req.url) == -1) {
            options.headers = options.headers
                .set('Content-Type', 'application/json')
                .set('Accept', 'application/json');
        }

        if ((this.appState !== undefined && this.appState.getCookie('authToken') !== undefined && this.appState.getCookie('authToken') != '')
            && this.excludeAuthorizationHeader.indexOf(req.url) == -1) {
            options.headers = options.headers
                .set('Authorization', `Bearer ${this.appState.getCookie('authToken')}`);
        }

        let apiReq = req.clone(options);

        let self = this;
        return next.handle(apiReq)
            .catch(errorReponse => {
                if (errorReponse instanceof HttpErrorResponse) {
                    let errMsg: any = `${errorReponse.status} - ${errorReponse.statusText || ''} - ${errorReponse.url}`;
                    if (errorReponse.error instanceof Blob) {
                        errMsg = 'Content could not be downloaded. Please try again later.'
                    } else if (typeof errorReponse.error === 'string' || errorReponse.error instanceof String) {
                        errMsg = errorReponse.error;
                    } else if (errorReponse.error) {
                        if (errorReponse.error.ExceptionMessage && errorReponse.error.ExceptionMessage.length) {
                            errMsg = errorReponse.error.ExceptionMessage;
                        } else if (errorReponse.error.Message && errorReponse.error.Message.length) {
                            errMsg = errorReponse.error.Message;
                        }                       
                    }

                    self.alertService.error(errMsg);

                    if (errorReponse.status === 401 || errorReponse.status === 403) {
                        self.router.navigate([this.loginUrl]);
                    }
                }
                return Observable.throw(errorReponse);
            });
    }

    private baseUrl() {
        var returnVal: string = process.env.APIUrl;
        return returnVal;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/helpers/http.APIInterceptor.ts